"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-lorenzo-del-vallo": {
    "76b57388": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "canalicchio": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a07d006e": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "ciccarello": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1d0dc0cd": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "comunella": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9795471": [{
      "hkey": "537342ad",
      "slug": "fedula-valle-del-gelso-e-di-paola",
      "name": "Fedula-Valle del Gelso e di Paola",
      "primary": true,
      "skipSearch": false
    }],
    "fedula": [{
      "hkey": "537342ad",
      "slug": "fedula-valle-del-gelso-e-di-paola",
      "name": "Fedula-Valle del Gelso e di Paola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "75c84ef1": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "ischievote": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "938be5fd": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "laccata": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "507cfe07": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "lupara": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c36b063a": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "san-leonardo": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03ddec3a": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "serralto": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf3f4411": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "skipSearch": false
    }],
    "terzo-di-firmo": [{
      "hkey": "e58258b8",
      "slug": "san-lorenzo-del-vallo",
      "name": "San Lorenzo del Vallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8079a33d": [{
      "hkey": "537342ad",
      "slug": "fedula-valle-del-gelso-e-di-paola",
      "name": "Fedula-Valle del Gelso e di Paola",
      "primary": true,
      "skipSearch": false
    }],
    "valle-del-gelso-e-di-paola": [{
      "hkey": "537342ad",
      "slug": "fedula-valle-del-gelso-e-di-paola",
      "name": "Fedula-Valle del Gelso e di Paola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-lorenzo-del-vallo"
    }]
  }
};
exports["default"] = _default;